
import DateTimeFormatOptions = Intl.DateTimeFormatOptions;
import NumberFormatOptions = Intl.NumberFormatOptions;

export const intlFormats: {
  time: {[key:string]: DateTimeFormatOptions},
  number: {[key:string]: NumberFormatOptions}
} = {
  time: {
    'MM:SS': {
      hour12: false,
      minute: 'numeric',
      second: '2-digit'
    },
    'short': {
      hour12: false,
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  number: {
    'currency': {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }
};



// WEBPACK FOOTER //
// ./src/intl.ts